import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import st from './CommonSubForm.module.sass';
import { useCreateHandlerTranslation } from '../create-handler/i18n.ts';
import { OwnerDepartmentSelect } from '../create-handler/OwnerDepartmentSelect.tsx';

function CommonSubForm() {
  const { t } = useCreateHandlerTranslation();
  const {
    control, register, setValue, formState: { errors },
  } = useFormContext();

  return (
    <React.Fragment>
      <SettingsItemWrapper
        contentClassName={st.Field}
        title={t('other_scenario.name')}
        titleClassName={st.FieldTitle}
      >
        <Control.Input
          autoFocus
          errors={errors}
          {...register('description', {
            maxLength: validate.maxLength(128),
            required: validate.required(),
          })}
        />
      </SettingsItemWrapper>
      <SettingsItemWrapper
        contentClassName={st.Field}
        title={t('form.owner_department')}
        titleClassName={st.FieldTitle}
      >
        <OwnerDepartmentSelect
          control={control}
          errors={errors}
          setValue={setValue}
        />
      </SettingsItemWrapper>
    </React.Fragment>
  );
}

export default CommonSubForm;
